export const globalContentsRegistry = new Set(['HEADER', 'FOOTER', 'REDIRECTS', 'POPUP', 'PROMOBAR']);
